import es from './es-api';

let clusterInfo = {
  data : {},
  info: ()=>{
    if (!clusterInfo.data.info){
      es.get('', data=>{
        clusterInfo.data.info = data;
      });
    }
    return clusterInfo.data.info;
  },
  index : {
    stats : ()=>{
      if (!clusterInfo.data.stats){
        es.get(es.ep._stats, data=>{
          clusterInfo.data.stats = data;
        });
      }
      return clusterInfo.data.stats;
    }
  },
  nodes : {
    stats : node=>{
      if(!clusterInfo.data.nodes) clusterInfo.data.nodes = {};
      if (!clusterInfo.data.nodes.stats){
        es.get(es.ep.nodes.stats, data=>{
          clusterInfo.data.nodes.stats = data;
        });
      }
      if(node){
        return clusterInfo.data.nodes.stats.nodes[node];
      }else{
        return clusterInfo.data.nodes.stats;
      }
    },
    info : node=>{
      if(!clusterInfo.data.nodes) clusterInfo.data.nodes = {};
      if (!clusterInfo.data.nodes.info){
        es.get(es.ep._nodes, data=>{
          clusterInfo.data.nodes.info = data;
        });
      }
      if(node){
        return clusterInfo.data.nodes.info.nodes[node];
      }else {
        return clusterInfo.data.nodes.info;
      }
    }
  },
  plugins : ()=>{
    if(!clusterInfo.data.nodes) clusterInfo.data.nodes = {};
    if (!clusterInfo.data.nodes.plugins){
      es.get(es.ep.nodes.plugins, data=>{
        clusterInfo.data.nodes.plugins = data;
      });
    }
    return clusterInfo.data.nodes.plugins;
  },
  cluster : {
    state : ()=>{
      if(!clusterInfo.data.cluster) clusterInfo.data.cluster = {};
      if (!clusterInfo.data.cluster.state){
        es.get(es.ep.cluster.state, data=>{
          clusterInfo.data.cluster.state = data;
        });
      }
      return clusterInfo.data.cluster.state;
    },
    health : ()=>{
      if(!clusterInfo.data.cluster) clusterInfo.data.cluster = {};
      if (!clusterInfo.data.cluster.health){
        es.get(es.ep.cluster.health, data=>{
          clusterInfo.data.cluster.health = data;
        });
      }
      return clusterInfo.data.cluster.health;
    }
  },
  template : ()=>{
    if(!clusterInfo.data.template){
      es.get(es.ep._template, data=>{
        clusterInfo.data.template = data;
      });
    }
    return clusterInfo.data.template;
  }
}

export default clusterInfo;


// WEBPACK FOOTER //
// ./src/scripts/data/cluster-info.js